/**
 * Shared API types � used across all features.
 * Feature-specific request/response contracts live in each feature's models/ folder.
 */

// --- Shared -----------------------------------------------------------------

/** Generic status used by Rewards, TimeSlots, Donors etc. */
export enum ApiStatus {
  Active = 1,
  Inactive = 2
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export interface PaginatedResult<T> {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: T[];
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
}

export interface ValidationProblemDetails extends ProblemDetails {
  errors: Record<string, string[]>;
}

export interface PaginationParams {
  PageNumber?: number;
  PageSize?: number;
  SortCriteria?: string;
  SearchTerm?: string;
  /** When true the server returns all records without server-side paging. */
  ClientSidePagination?: boolean;
}
